import React, { useContext, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

import { useTheme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import UserService from "../../services/UserService";
import TopBar from "../TopBar";
import LanguageContext from "../../LanguageContext";
import messages from "../../services/messages";

import StateService from "../../services/StateService";
import useMediaQuery from "@mui/material/useMediaQuery";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Paper from "@mui/material/Paper";
import firebase from "../../firebase";

import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

import WhyReason from "./WhyReason";
import BottomBar from "../BottomBar";

let mhState = {
  code: "MH",
  language: { name_en: "marathi", code: "mr", name_vernacular: "मराठी" },
  name_en: "maharashtra",
  name_vernacular: "महाराष्ट्र",
};
const useStyles = makeStyles((theme) => ({
  main: {
    minHeight: window.innerHeight,
    backgroundColor: "#FFFFFF",
  },
  input: {},

  infoCardWrapper: {
    flex: "0 0 auto",
  },

  signupContainer: {
    marginTop: theme.spacing(1),
  },
  signupFormContainer: {},
  tnc: {
    // marginBottom: theme.spacing(2),
  },
  tnc2: {
    marginBottom: theme.spacing(2),
  },
  tncText: {
    textAlign: "center",
  },
  errorMessage: {
    color: "red",
  },
}));

export default function FreeContainer(props) {
  const classes = useStyles();
  const language = useContext(LanguageContext);

  let history = useHistory();
  const [rememberMe, setRememberMe] = React.useState(true);

  const [mobile, setMobile] = React.useState("");
  const [mode, setMode] = React.useState("");

  const [signupFailureMessage, setSignupFailureMessage] = React.useState("");

  const [state, setState] = React.useState("");
  const [userState, setUserState] = React.useState(mhState);
  let [states, setStates] = React.useState(props.states || []);
  let params = useParams();

  let userStateName = userState ? userState.name_en : "maharashtra";
  useEffect(() => {
    if (props.userState) {
      setUserState(props.userState);
    }
    if (props && props.states && props.states.length > 0) {
      setStates(props.states);
    }
    firebase.analytics().logEvent("signup_page_viewed", {
      state_name: props.userState ? props.userState.name_en : mhState.name_en,
    });

    UserService.checkPremium() ? history.push("/dashboard") : void 0;
  }, [props.userState]);

  const handleChangeMobile = (event) => {
    setMobile(event.target.value);
  };

  const handleChangeState = (event) => {
    setState(event.target.value);
  };

  const saveUserAndRedirect = (isNew) => {
    UserService.saveUser("", mobile, userStateName, true, false, isNew);
    firebase.analytics().logEvent("signup_success", {
      mobile: mobile,
      stateName: userState.name_en.toLowerCase(),
    });
    history.push("/dashboard");
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    firebase.analytics().logEvent("onboardinginfo_submitted", {
      state_name: userStateName,
      mobile,
    });

    if (mode === "" || mode === undefined) {
      UserService.signup("", mobile, userState, "WEB")
        .then(async (response) => {
          if (response && response.data) {
            if (response.data.result === "success") {
              setSignupFailureMessage("");
              saveUserAndRedirect(response.data.isNew);
            } else {
              if (response.data.data) {
                saveUserAndRedirect(response.data.data.isNew);
              } else {
                let eventData = {
                  state_name: userStateName,
                  mobile,
                };

                if (response.data.message) {
                  eventData.reason = response.data.message;
                  setSignupFailureMessage(response.data.message);
                }
                firebase.analytics().logEvent("joingold_failed", eventData);
              }
            }
          }
        })
        .catch((error) => {
          setSignupFailureMessage(`SOMETHING_WENT_WRONG`);
          firebase.analytics().logEvent("joingold_failed", {
            state_name: userStateName,
            mobile,
            reason: "SOMETHING_WENT_WRONG",
          });
        });
    } else if (mode === "pay") {
    } else {
    }
  };

  const theme = useTheme();
  const isLessThanSmall = useMediaQuery(theme.breakpoints.down('md'));
  const fullScreen = isLessThanSmall;

  return <>
    <div className={classes.main}>
      <TopBar location={"join"} />
      <div className={classes.signupContainer}>
        {props && props.paymentPackage && (
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="flex-start"
          >
            <Grid item xs={12} sm={8} md={5} lg={3}>
              <Paper elevation={0} className={classes.signupCard}>
                <CardContent>
                  <form onSubmit={handleSubmit}>
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Grid item>
                        <Typography
                          variant={"h6"}
                          style={{ fontWeight: "bold" }}
                        >
                          {messages["free.classWaiting"][language]}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Grid item>
                        <Typography variant={"body2"}>
                          {messages["free.createProfile"][language]}
                        </Typography>
                      </Grid>
                    </Grid>
                    <br />
                    <Grid
                      className={classes.signupFormContainer}
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="flex-start"
                      spacing={2}
                    >
                      <Grid item xs={12}>
                        <Grid
                          container
                          direction="row"
                          justifyContent="center"
                          alignItems="flex-start"
                        >
                          <Grid item xs={12}>
                            <TextField
                              id="mobile"
                              className={classes.input}
                              onChange={handleChangeMobile}
                              value={mobile}
                              variant={"outlined"}
                              required={true}
                              inputProps={{
                                type: "tel",
                                minLength: "10",
                                maxLength: "10",
                                pattern: "[0-9]+",
                                title:
                                  messages["join.form.mobileValidation"][
                                    language
                                  ],
                              }}
                              autoFocus={true}
                              name={"mobile"}
                              fullWidth
                              label={messages["login.form.mobile"][language]}
                              autoComplete={"tel"}
                            />
                          </Grid>
                        </Grid>

                        <>
                          <br />
                          <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="flex-start"
                          >
                            <Grid item xs={12}>
                              <FormControl
                                fullWidth
                                required
                                variant="outlined"
                              >
                                <InputLabel htmlFor="select-state">
                                  {" "}
                                  {messages["login.form.state"][language]}
                                </InputLabel>
                                <Select
                                  native={true}
                                  label={
                                    messages["login.form.state"][language]
                                  }
                                  value={userState.name_en}
                                  inputProps={{
                                    name: "state",
                                    id: "select-state",
                                  }}
                                  onChange={(event) => {
                                    let newUserState =
                                      StateService.getStateByName(
                                        props.states,
                                        event.target.value.toLowerCase()
                                      );

                                    setUserState(newUserState);
                                    userStateName = newUserState.name_en;
                                  }}
                                >
                                  {props.states.map((state, index) => {
                                    return (
                                      <option value={state.name_en}>
                                        {state.name_vernacular}
                                      </option>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                            </Grid>
                          </Grid>
                        </>
                      </Grid>
                      {signupFailureMessage && signupFailureMessage !== "" && (
                        <Grid
                          container
                          direction="row"
                          justifyContent="center"
                          alignItems="flex-start"
                        >
                          <Grid item>
                            {signupFailureMessage === "INVALID_MOBILE" && (
                              <Typography
                                variant={"body1"}
                                className={classes.errorMessage}
                              >
                                {messages["signup.invalidMobile"][language]}
                              </Typography>
                            )}
                          </Grid>
                        </Grid>
                      )}
                    </Grid>
                    <br />
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      className={classes.tnc}
                    >
                      <Grid item xs={8}>
                        <Typography variant={"caption"} align={"center"}>
                          {messages["signup.tncStart"][language]}{" "}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      className={classes.tnc2}
                    >
                      <Grid item xs={6}>
                        <Typography variant={"caption"} align={"center"}>
                          {" "}
                          <a href={messages["footer.tncLinks"][language]}>
                            {messages["signup.tncText"][language]}
                          </a>
                          {messages["signup.tncEnd"][language]}{" "}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Grid item>
                        <Button
                          variant={"contained"}
                          color={"primary"}
                          type={"submit"}
                          size={"large"}
                          endIcon={<ArrowForwardIcon />}
                        >
                          {messages["free.signup"][language]}
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                  <br />
                  <WhyReason />
                </CardContent>
              </Paper>
              <br />
            </Grid>
          </Grid>
        )}
        <BottomBar
          languages={props.languages}
          location={"dashboard"}
          changeUserLanguage={props.changeUserLanguage}
        />
      </div>
    </div>
  </>;
}
